import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MediaType } from '@app/store/shared/models';

export function getTypeOptions(): { label: string; value: MediaType }[] {
    const translateService = inject(TranslateService);

    return [
        { label: translateService.instant('media.type.image'), value: 'image' },
        { label: translateService.instant('media.type.video'), value: 'video' },
        { label: translateService.instant('media.type.audio'), value: 'audio' },
        { label: translateService.instant('media.type.pdf'), value: 'pdf' },
        { label: translateService.instant('media.type.text'), value: 'text' },
    ];
}
